export const responses = {
    throwErr(err){
        return Swal.fire(
            `An Error Occurred`,
            `<p>${err}</p>`,
            `error`,
        )
    },

    showSuccess(msg){
        return Toast.fire({
            icon: 'success',
            title: msg
        });
    },

    showInfo(msg){
        return Toast.fire({
            icon: 'info',
            title: msg
        });
    },

    showWarning(msg){
        return Toast.fire({
            icon: 'warning',
            title: msg
        });
    },
}
